import store from '@/stores/MainStore';

const alertLevels = {
  success: {
    level: 'success',
    color: 'success',
    icon: 'check_circle',
  },
  info: {
    level: 'info',
    color: 'info',
    icon: 'info',
  },
  warning: {
    level: 'warning',
    color: 'warning',
    icon: 'priority_high',
  },
  error: {
    level: 'error',
    color: 'error',
    icon: 'warning',
  },
};

const snackbarPosition = {
  topLeft: {
    top: true,
    bottom: false,
    left: true,
    right: false,
  },
  top: {
    top: true,
    bottom: false,
    left: false,
    right: false,
  },
  topRight: {
    top: true,
    bottom: false,
    left: false,
    right: true,
  },
  bottomLeft: {
    top: false,
    bottom: true,
    left: true,
    right: false,
  },
  bottom: {
    top: false,
    bottom: true,
    left: false,
    right: false,
  },
  bottomRight: {
    top: false,
    bottom: true,
    left: false,
    right: true,
  },
};

const clearNotifications = () => {
  store.dispatch('notificationsStore/hideAlert');
  store.dispatch('notificationsStore/hideSnackbar');
};

if (store) {
  store.watch(state => state.drawerStore.currentPath, () => {
    clearNotifications();
  });
}

const clearNetworkNotification = () => {
  store.dispatch('notificationsStore/hideNetworkAlert');
};

const showAlert = (alert) => {
  const defaultAlert = {
    message: 'Alert',
    level: 'info',
    timeout: 0,
  };

  let alertObj = Object.assign({}, defaultAlert, alert);
  alertObj = Object.assign({}, alertObj, alertLevels[alertObj.level]);

  store.dispatch('notificationsStore/showAlert', alertObj);

  if (alertObj.timeout > 0) {
    setTimeout(() => {
      store.dispatch('notificationsStore/hideAlert');
    }, alertObj.timeout);
  }
};

const showSnackbar = (snackbar) => {
  const defaultSnackbar = {
    message: 'Alert',
    messageParams: {},
    timeout: 0,
    position: 'bottom',
  };

  let snackObj = Object.assign({}, defaultSnackbar, snackbar);
  snackObj = Object.assign({}, snackObj, {
    position: snackbarPosition[snackObj.position],
  });

  store.dispatch('notificationsStore/showSnackbar', snackObj);
};

const showUnsavedChangesModal = (data) => {
  const defaultModal = {
    header: 'Discard changes?',
    body: 'There are unsaved changes. Are you sure you want to close without saving?',
    agreeCallback: () => {},
  };

  const modalObj = Object.assign({}, defaultModal, data);

  store.dispatch('notificationsStore/showUnsavedChangesModal', modalObj);
};

export default {
  showAlert,
  showSnackbar,
  clearNotifications,
  clearNetworkNotification,
  showUnsavedChangesModal,
};
